import { isEmpty } from "lodash";
import { ActionIcon } from "PFComponents/action_icon";
import { ConfigTemplateInputItem } from "PFTypes/config_template";
import React from "react";

import { InputField } from "./input_field";
import { NotSupportedField } from "./not_supported_field";
import css from "./properties_fields.module.scss";

type ArrayFieldItemProps = {
  index: number;
  entryFieldName: string;
  onRemove: () => void;
} & ConfigTemplateInputItem;

export const ArrayFieldEntry = ({ entryFieldName, onRemove, type, properties }: ArrayFieldItemProps) => {
  if (type === "string") {
    return (
      <div className={css.arrayItem}>
        <InputField fieldName={entryFieldName} label=" " type="string" required />
        <ActionIcon name="remove" size="xs" onClick={onRemove} />
      </div>
    );
  }

  if (type === "object" && !isEmpty(properties)) {
    return (
      <div className={css.arrayItem}>
        {Object.entries(properties).map(([property, props]) => (
          <InputField
            key={`${entryFieldName}.${property}`}
            fieldName={`${entryFieldName}.${property}`}
            label={property}
            type="string"
            {...props}
          />
        ))}
        <ActionIcon name="remove" size="xs" onClick={onRemove} />
      </div>
    );
  }

  return <NotSupportedField fieldName={entryFieldName} type={"array"} label={type} required={false} />;
};
